import { http } from '@/lib/http'

export interface UserProfile {
  id: string
  email?: string
  name: string | null
  aiName: string
  role: 'helper' | 'friend' | 'assistant'
  onboardingCompleted: boolean
  isPaidAccount: boolean
  planPrice: number | null
  userNumber: number | null
  planLockedAt: number | null
}

export interface SessionStatusResponse {
  valid: boolean
  userId?: string
  email?: string
  user?: UserProfile
}

export async function getSessionStatus(
  authToken: string | null,
  guestId?: string
) {
  const headers: Record<string, string> = {}
  if (guestId) headers['X-Guest-Id'] = guestId

  const response = await http.get<SessionStatusResponse>('/auth/session', {
    authToken,
    headers,
  })

  return response.data
}

export async function logout(authToken: string | null) {
  await http.post('/auth/logout', {}, { authToken })
}

